module.exports = __webpack_public_path__ + "profile-4-m-oXn.png";